// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Lato_8fb32a', '__Lato_Fallback_8fb32a'","fontStyle":"normal"},"className":"__className_8fb32a"};